import { render, staticRenderFns } from "./VerifyToken.vue?vue&type=template&id=6b18ae50&scoped=true&"
import script from "./VerifyToken.vue?vue&type=script&lang=js&"
export * from "./VerifyToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18ae50",
  null
  
)

export default component.exports